module.exports = __webpack_public_path__ + "static/img/banner5.6378251.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner5.png
// module id = qc1Z
// module chunks = 52